<template>
    <div>
        <Headers  :title="title"/>
        <img class="GDTE" src="~statics/mobileShouye/GDTE.png" alt="">
        <iframe  class="iframe"  :src="iframesrc"  style="border:0;" ></iframe> 
        <div class="detaileMenu">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/guest.png" alt="" @click="goGuset">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/rili.png" alt="" @click="goSchedule">
        </div>
        <Footers />
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
import Footers from "../mobileConsult/components/Footers";
import { mapState } from "vuex";
import api from "@/api";

export default {
    data(){
        return{
           exhibition_id: '',
        //    title: ''
            entitle: null,
            cntitle: null,
            iframesrc: ''
        }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return  this.language == 'zh' ?  this.cntitle : this.entitle
        },
        ...mapState(["userInfo","language"]),
    },
    created() {
        this.exhibition_id = this.$route.query.exhibition_id;
        this.handleGetExhibitor()
        switch (Number(this.exhibition_id)) {
          case 21:
            this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=f3835ca95db93922";
            break;
          case 25:
            this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=1e70d51ed7c2cbd3";
            break;
            case 31:
            this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=908dc3b88008886d";
            break;
            case 50:
            this.iframesrc = "https://veh.cloudvhall.com/#/preview/SFZWc2ZVK25ES211MVM2dm83WExpQT09";
            break;
            case 60:
            this.iframesrc = "https://veh.cloudvhall.com/#/preview/SytuR2hocFYwTkxhbGJQOFFuTUhyZz09";
            break;
          default:
            break;
        }
    },
    mounted(){
    },
    methods: {
        goSchedule(){
            this.$router.push({
                path: '/schedule',
                // query: {
                //     exhibition_id: _id
                // }
            })
        },
        goGuset(){
            this.$router.push({
                path: '/mobileGuest',
                // query: {
                //     exhibition_id: _id
                // }
            })
        },
        handleGetExhibitor(){
            api.getExhibitor({
                exhibition_id: this.exhibition_id
            }).then((res)=> {
                if(res.res ==1){
                    this.exhibitorData = res.list
                    this.entitle = res.list[0].vhall.exhibition_name.en.name
                    this.cntitle = res.list[0].vhall.exhibition_name.cn.name
                }else{
                    this.$message.error(res.mes);
                }
            })
        },
    },
    components: {
        Headers,
        Footers
    },
}
</script>

<style lang="scss" scoped>
// /deep/ .van-tabbar{
//     height: 1.74rem;
// }

/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}
.detaileMenu{
    position: absolute;
    display: flex;
    flex-direction: column;
    bottom: 1.94rem;
    right: .14rem;
    .detaileMenu-icon{
        width: 1.12rem;
        height: 1.12rem
    }
}
.GDTE{
    width: 3.56rem;
    height: .4;
    margin: .3rem 0 0 .3rem;
    position: absolute;
    z-index: 999;
}
.iframe{
    width: 100%;
    border: 0px;
    height: 17rem;
    position: absolute;
    // top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileMeetHall/index.vue